export default "__VITE_ASSET__DNZZGTD___"